import {
    SET_RATING,
    RESET_REVIEW_FORM,
    UPDATE_REVIEW,
    SET_REVIEW_IMAGES,
    REVIEW_ERRORS,
    REVIEW_SUBMITTED,
    REVIEW_SUBMITTED_LOADING
} from './types'
import axios from 'axios'


export const newReview = (data: any) => (dispatch: any) => {
    dispatch({
        type: REVIEW_SUBMITTED_LOADING
    })
    axios.post('/api/reviews/newReview', data)
        .then(res => {
            dispatch({
                type: REVIEW_SUBMITTED
            })
        })
        .catch(err => {
            dispatch({
                type: REVIEW_ERRORS,
                payload: err.response.data
            })
        })
}

export const setImages = (data: any) => (dispatch: any) => {
    dispatch({
        type: SET_REVIEW_IMAGES,
        payload: data
    })
}

export const resetReviewForm = () => (dispatch: any) => {
    dispatch({
        type: RESET_REVIEW_FORM
    })
}

export const setRating = (rating: number) => (dispatch: any) => {
    dispatch({
        type: SET_RATING,
        payload: rating
    })
}

export const updateReview = (field: string, value: any) => (dispatch: any) => {
    dispatch({
        type: UPDATE_REVIEW,
        payload: { field, value }
    })
}





